import { Modal } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import useCustomHook from "../../../reducers/ContentCreateHook";
import {LoadingSpinner} from '../../../components/Icons';
import CustomIconButton from "../../../components/CustomIconButton";
import { formatPadStartNumber, formatDateTime } from "../../../utils/format";
import CustomDatePicker from "../../../components/CustomDatePicker";
import TimeInput from "../../../components/TimeInput";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTextarea from "../../../components/CustomTextarea";
import TextInput from "../../../components/TextInput";
import JobPostPanel from "../../company_chat/components/JobPostPanel";
import talentAvatar from '../../../../assets/img/noAvatar.png';
import {
  setIsDiscardUnsentMessagePopup,
  setIsOpenListJobPanel,
  setJobSelected,
  setPendingPath,
} from "reducers/chatMessage";
import { addActionItems } from "reducers/action";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSnackbar } from "notistack";
import CustomToast from "../../../components/CustomToast";
import { MAX_FILE_SIZE } from "../../../constants/index";
import Dropdown from "../../../components/Dropdown";
import { formatName } from "utils/format";
import i18n from 'i18next';

const StatusSelectionModal = ({ open, onClose, onConfirm, onConfirmPopupOpen }: any) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isPublishReserved, setIsPublishReserved] = useState(false);
  const { chatSelected, jobSelected, talentSelected, isOpenListJobPanel, action, actionItems, isMessageFormDirty, isDiscardUnsentMessagePopup } = useSelector((state: any) => state.chatMessage);
  const { optionsRelatedAction } = useSelector((state: any) => state.action);
  const inputRef = useRef(null);
  const [files, setFiles] = useState<any[]>([]);
  const [content, setContent] = useState("");
  const [status, setStatus] = useState({id: null, name: 'ステータス'});
  const [staff, setStaff] = useState({id: null, name: '担当者'});
  const [formErrors, setFormErrors]: any = useState({action_status: '', staffs: ''});
  const [isSaving, setIsSaving] = useState(false);

  const showToast = (title: any, mes: any, variant: any) => {
    enqueueSnackbar("I love snacks.", {
      autoHideDuration: 7000,
      content: (key) => (
        <CustomToast title={title} message={mes} variant={variant}
          snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };

  const validateAddUpdate = (status: any, staff: any) => {
    let formErrorCheck = { action_status: '', staffs: '' }

    let result = true
    if(!status?.id) {
      formErrorCheck.action_status = "ステータスの入力は必須です。"
      result = false
    }
    if(!staff?.id) {
      formErrorCheck.staffs = "担当者の入力は必須です。"
      result = false
    }
    setFormErrors(formErrorCheck)
    return result
  }

  const handleCreateActionItem = () => {
    // Validate
    const isValid = validateAddUpdate(status, staff)
    if(!isValid) { return }
    setIsSaving(true)

    const data = {
      staff_id: staff?.id,
      status_id: status?.id,
      content: content
    }
    dispatch(addActionItems({ id: Number(action?.id), requestBody: data }));
  };

  const navigateToActionDetail = () => {
    if(isMessageFormDirty && !isDiscardUnsentMessagePopup) {
      dispatch(setIsDiscardUnsentMessagePopup(true));
      dispatch(setPendingPath("/company/action/edit/" + action?.id));
    } else {
      if(action?.id) navigate("/company/action/edit/" + action?.id);
    }
  }

  return (
    <Modal open={open} onClose={onClose}>
      <div className="bg-white rounded-2xl p-6 min-w-[580px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] outline-none overflow-y-auto custom-scrollbar">
        <div className="flex justify-between mb-2">
          <h2 className="text-xl font-bold alu-text-base-2">選考状況の更新</h2>
          <CustomButton variant="text" onClick={() => navigateToActionDetail()}>
            選考状況をもっと見る
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clip-path="url(#clip0_1225_6513)">
                <path d="M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z" fill="#FF861A"/>
              </g>
              <defs>
                <clipPath id="clip0_1225_6513">
                  <rect width="16" height="16" rx="4" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </CustomButton>
        </div>
        <p className="text-xs alu-text-base-2 mb-4">選考状況を更新します。</p>

        {/* タレント情報 */}
        <div className="mb-4 rounded-lg border border-[#E0E0E0]">
          <div className="grid grid-cols-4 gap-4 py-2 px-4 bg-[#E9E9E9]">
            <p className="text-sm alu-text-base-1">タレント</p>
            <p className="text-sm alu-text-base-1">更新日時</p>
            <p className="text-sm alu-text-base-1">ステータス</p>
            <p className="text-sm alu-text-base-1">担当者</p>
          </div>
          {actionItems?.slice(0, 1).map((action: any, idx: any) => (
            <div className="grid grid-cols-4 gap-4 py-2 px-4 border-b border-b-[#E0E0E0] alu-text-base-2 items-center">
              <div className="flex items-center gap-2">
                <img src={talentSelected?.talent?.avatar ? talentSelected?.talent?.avatar : talentAvatar} alt="avatar" className="w-12 h-12 rounded-full" />
                <p className="text-sm">{formatName(talentSelected?.talent?.first_name, talentSelected?.talent?.last_name)}</p>
              </div>
              <p className="text-sm">{formatDateTime(action?.created_at)}</p>
              <div className="">
                <span className="rounded-2xl bg-[#e0e0e0] text-[#343a3d] text-sm px-2 py-0.5">{action?.status_str}</span>
              </div>
              <div className="text-sm">{formatName(action?.staff?.first_name, action?.staff?.last_name)}</div>
            </div>
          ))}

          <div className="py-3 px-4">
            {/* ステータス・担当者 */}
            <div className="grid grid-cols-2 gap-8 mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <label className="block text-sm font-bold min-w-[82px] alu-text-base-2">
                    ステータス <span className="text-red-500">*</span>
                  </label>
                  <div>
                    <Dropdown
                      error={formErrors.action_status}
                      placeholder="" 
                      options={optionsRelatedAction?.action_status}
                      value={status} 
                      onChange={(value: any) => setStatus(value)} 
                      />
                  </div>
                </div>
                {formErrors.action_status && (
                  <div className="flex items-center gap-2 mt-2">
                    <label className="block text-sm font-bold min-w-[82px] alu-text-base-2">
                    </label>
                    <p className="alu-text-error text-sm">
                      {formErrors.action_status}
                    </p>
                  </div>
                )}
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <label className="block text-sm font-bold min-w-[54px] alu-text-base-2">
                    担当者 <span className="text-red-500">*</span>
                    </label>
                    <div>
                      <Dropdown
                        error={formErrors.staffs}
                        placeholder="" 
                        options={optionsRelatedAction?.staffs}
                        value={staff} onChange={(value: any) => setStaff(value)} 
                      />
                    </div>
                </div>
                {formErrors.staffs && (
                  <div className="flex items-center gap-2 mt-2">
                    <label className="block text-sm font-bold min-w-[54px] alu-text-base-2">
                    </label>
                    <p className="alu-text-error text-sm">
                      {formErrors.staffs}
                    </p>
                  </div>
                )}
              </div>
            </div>
            {/* 連絡事項 */}
            <div className="flex gap-2">
              <label className="block text-sm font-bold min-w-[80px] alu-text-base-2">連絡事項</label>
              <div className="w-full">
                <CustomTextarea
                  rows={4}
                  size="md"
                  isResizable={false}
                  value={content}
                  onChange={(e: any) => setContent(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* ボタン */}
        <div className="flex justify-center items-center gap-8">
          <CustomButton
            onClick={onClose}
            variant="text"
          >
            キャンセル
          </CustomButton>
          <CustomButton size="md"
            disabled={isSaving}
            onClick={handleCreateActionItem}>
            決定
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default StatusSelectionModal;
